/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormElementSnapshotDto } from './FormElementSnapshotDto';
import {
    FormElementSnapshotDtoFromJSON,
    FormElementSnapshotDtoFromJSONTyped,
    FormElementSnapshotDtoToJSON,
    FormElementSnapshotDtoToJSONTyped,
} from './FormElementSnapshotDto';

/**
 * 
 * @export
 * @interface FormElementSubSectionSnapshotDto
 */
export interface FormElementSubSectionSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionSnapshotDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSubSectionSnapshotDto
     */
    subtitle?: string;
    /**
     * 
     * @type {Array<FormElementSnapshotDto>}
     * @memberof FormElementSubSectionSnapshotDto
     */
    elements: Array<FormElementSnapshotDto>;
}

/**
 * Check if a given object implements the FormElementSubSectionSnapshotDto interface.
 */
export function instanceOfFormElementSubSectionSnapshotDto(value: object): value is FormElementSubSectionSnapshotDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('elements' in value) || value['elements'] === undefined) return false;
    return true;
}

export function FormElementSubSectionSnapshotDtoFromJSON(json: any): FormElementSubSectionSnapshotDto {
    return FormElementSubSectionSnapshotDtoFromJSONTyped(json, false);
}

export function FormElementSubSectionSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementSubSectionSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'elements': ((json['elements'] as Array<any>).map(FormElementSnapshotDtoFromJSON)),
    };
}

export function FormElementSubSectionSnapshotDtoToJSON(json: any): FormElementSubSectionSnapshotDto {
    return FormElementSubSectionSnapshotDtoToJSONTyped(json, false);
}

export function FormElementSubSectionSnapshotDtoToJSONTyped(value?: FormElementSubSectionSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'subtitle': value['subtitle'],
        'elements': ((value['elements'] as Array<any>).map(FormElementSnapshotDtoToJSON)),
    };
}

